// constant addition
export default Object.freeze({
  RESPONSES_STATUS: {
    OK: 200,
  },
  GO_API_RESPONCE_SUCCESSFUL: 0,
  WEBIAM_api_responce_successful: 0,
  userSearchPattern: '**##@@!*',
  USERID_MIN_LENGTH: 4,
  USERID_MAX_LENGTH: 30,
  OLDPASSWORD_MIN_LENGTH: 8,
  OLDPASSWORD_MAX_LENGTH: 15,
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_MAX_LENGTH: 15,
  EMAIL_MAX_LENGTH: 100,
  ORGANISATION_MAX_LENGTH: 30,
  MATTABLE_CELL_HEIGHT: 50,
  UNAUTHORIZED_ACCESS: 401,
  USER_BLOCKED: 10091,
  TOKEN_EXPIRED: 11000,
  INVALID_ACT_LINK: 10167,
  DBAS_MEMBERSHIP_CHANGED: 10170,
  USER_ROLE_CHANGED: 10120,
  ERROR_MFA_YN_CHANGED: 10134,
  COMMON_ERROR: 0,
  IAM_PREFIX: 'iam_',
  NO_TOKEN_LENGTH: 9,
  ERROR_CODE_LENGTH: 5,
  MOBILE_NUMBER_LENGTH: 10,
  OTP_LENGTH: 6,
  OTK_LENGTH: 200,
  IAM_TAG: 'iam',
  SVC_ACTION_CODE_START: 7,
  SVC_ACTION_CODE_STOP: 12,
  RESOURCE_CONNECTED: 20,
  INVAILD_WHITELISTED_DOMAIN_POPUP_AUTO_HIDE_TIMER: 10000,
  IAM_SYSTEM: 'IAM SYSTEM',
  AUDIT_COLUMN: 'audit',
  MIN_FILE_NAME_LENGTH: 5,
  MAX_FILE_NAME_LENGTH: 30,
  MIN_AUDIT_COMMENT_LENGTH: 20,
  MAX_AUDIT_COMMENT_LENGTH: 255,
  PROJECT_ALL: 'all',
  VPC_NM_MIN_LENGTH: 3,
  VPC_NM_MAX_LENGTH: 50,
  ACC_ID_MIN_LENGTH: 3,
  ACC_ID_MAX_LENGTH: 50,

  CMPN_NM_MIN_LENGTH: 3,
  CMPN_NM_MAX_LENGTH: 50,
  RQTR_ID_MIN_LENGTH: 3,
  RQTR_ID_MAX_LENGTH: 50,
  COMT_CONT_MIN_LENGTH: 3,
  COMT_CONT_MAX_LENGTH: 50,

  LOG_STRM_NM_MIN_LENGTH: 3,
  LOG_STRM_NM_MAX_LENGTH: 50,

  VPC_PEERING_ID_MAX_LENGTH: 50,
  VPC_PEERING_ID_MIN_LENGTH: 3,
  RDS_USER_MAX_LENGTH: 50,
  RDS_PWD_MIN_LENGTH: 8,
  RDS_PWD_MAX_LENGTH: 50,

  WINDOWS_USER_NAME_MAX_LENGTH: 256,
  WINDOWS_USER_PWD_MAX_LENGTH: 256,
  WINDOWS_USER_PWD_MIN_LENGTH: 1,

  LINUX_USER_NAME_MAX_LENGTH: 15,
  LINUX_USER_PWD_MAX_LENGTH: 1704,
  LINUX_USER_KEY_MAX_LENGTH: 5000,
  LINUX_USER_PWD_MIN_LENGTH: 6,
  MAX_ALLOWED_SVR_SELECTION: 10,

  BTN_TEXT_RETRY: 'Retry',
  BTN_TEXT_JOIN: 'Join',
  RNM_CMPTR: '2206',

  SVC_RSRC_GATHER_REQUIRED: 13001,
  SG_CREATE_MAX_ALLOWED: 20,

  PEM_START: '-----BEGIN RSA PRIVATE KEY-----',
  PEM_END: '-----END RSA PRIVATE KEY-----',

  CLOUDFRONT_TEST_FILE: '/status_check.txt',
  NAME: 'Name',
  AwsVpc: 'VPC',
  AzureVpc: 'V net',
  AwsID: 'Account',
  AzureID: 'Subscription',
  ID: 'Id',
  AwsVpcPeering: 'VPC Peering',
  AzureVpcPeering: 'V Net Peering',
  LocalIP: '127.0.0.1',
  LOCAL_PORT_NOT_SET: '- -',
  AzureCspName: 'azure',
  DBTYPE_Postgre: 'Microsoft.DBforPostgreSQL',
  DBTYPE_ServerGroup2: 'serverGroupsv2',

  IAM_JOIN_STATUS_CODE: [{ 300: 'Mapping Pending' }],

  USER_ROLE: {
    10: 'USER',
    20: 'ADMIN',
    30: 'DBA',
    40: 'Common DBA',
    50: 'Common EC2',
    60: 'Reader',
    70: 'Writer',
  },
  USER_ROLE2: {
    USER: 10,
    ADMIN: 20,
    DBA: 30,
    COMMON_DBA: 40,
    COMMON_EC2: 50,
    READER: 60,
    WRITER: 70,
  },

  RESOURCE_TYPE: {
    EC2: 'EC2',
    RDS: 'RDS',
    S3: 'S3',
    DYNAMODB: 'DYNAMODB',
    STORAGEACCOUNT: 'STORAGE ACCOUNT',
  },

  ENV_DASH_BOARD: [
    {
      value: '',
      text: 'All',
    },
    {
      value: 'DEV',
      text: 'DEV',
    },
    {
      value: 'STG',
      text: 'STG',
    },
    {
      value: 'PRD',
      text: 'PRD',
    },
  ],

  ENV_UNTAG: [
    {
      value: '-1',
      text: 'All',
    },
    {
      value: 'DEV',
      text: 'DEV',
    },
    {
      value: 'STG',
      text: 'STG',
    },
    {
      value: 'PRD',
      text: 'PRD',
    },
  ],

  ENV_TAG: [
    {
      value: 'DEV',
      text: 'DEV',
    },
    {
      value: 'STG',
      text: 'STG',
    },
    {
      value: 'PRD',
      text: 'PRD',
    },
  ],

  MONTHS: [
    { value: 'ALL', monthNumber: 0 },
    { value: 'JAN', monthNumber: 1 },
    { value: 'FEB', monthNumber: 2 },
    { value: 'MAR', monthNumber: 3 },
    { value: 'APR', monthNumber: 4 },
    { value: 'MAY', monthNumber: 5 },
    { value: 'JUN', monthNumber: 6 },
    { value: 'JUL', monthNumber: 7 },
    { value: 'AUG', monthNumber: 8 },
    { value: 'SEP', monthNumber: 9 },
    { value: 'OCT', monthNumber: 10 },
    { value: 'NOV', monthNumber: 11 },
    { value: 'DEC', monthNumber: 12 },
  ],

  // mat tabs for log management, must be equal to tab index for component
  LOG_TABS: {
    IAM: 2,
    SERVER: 1,
    PERM: 0,
    RDS: 3,
  },

  PERM_ACCESS_LOGS: {
    ALL: 0,
    PERM: 1,
    ACCESS: 2,
  },

  ACCESS_TYPE: {
    P: 'Permanent',
    T: 'Temporary',
    E: 'Emergency',
  },

  LOG_STATUS_MINOR: {
    status: 'MINOR',
    code: '9001',
  },

  LOG_STATUS_MAJOR: {
    status: 'MAJOR',
    code: '9002',
  },

  LOG_STATUS_CRITICAL: {
    status: 'CRITICAL',
    code: '9003',
  },
  LOG_STATUS_CRITICAL_ARR: {
    status: 'CRITICAL',
    code: ['9003', '9006', '9007', '9008', '9009', '9010', '9011', '9012'],
  },
  LOG_STATUS_LOGIN: {
    status: 'LOGIN',
    code: '9004',
  },
  LOG_STATUS_LOGOUT: {
    status: 'LOGOUT',
    code: '9005',
  },

  DOMAIN_JOIN_STATUS_CODE: {
    100: 'Success',
    2011: 'Mapping Pending',
    2012: 'Domain Join Pending',
    3001: 'RDS Info Fetch Pending',
    3002: 'RDS Role Apply Pending',
    3003: 'Error RDS Info Fetch',
    3004: 'Error RDS Role Creation',
    3008: 'RDS_READ_REPLICA_WRITER_NOT_ENGAGED',
    3011: 'RDS Mapping Pending',
    3012: 'RDS Mapping Completed',
    3021: 'RDS Connectivity Check Pending',
    5010: 'RDS Tag Change',
    6001: 'Agent Install Pending',
    6002: 'Agent Install Error',
  },

  profilePictures: [
    'assets/img/avtar/B1.jpg',
    'assets/img/avtar/B2.jpg',
    'assets/img/avtar/B3.jpg',
    'assets/img/avtar/B4.jpg',
    'assets/img/avtar/G1.jpg',
    'assets/img/avtar/G2.jpg',
    'assets/img/avtar/G3.jpg',
    'assets/img/avtar/G4.jpg',
    'assets/img/avtar/BB1.jpg',
    'assets/img/avtar/BB2.jpg',
    'assets/img/avtar/GG1.jpg',
    'assets/img/avtar/GG2.jpg',
    'assets/img/avtar/GG3.jpg',
    'assets/img/avtar/GG4.jpg',
  ],

  VOC_STATUS_PENDING: {
    status: 'Pending',
    code: 0,
  },

  VOC_STATUS_REPLIED: {
    status: 'Replied',
    code: 1,
  },

  VOC_STATUS_CLOSED: {
    status: 'Closed',
    code: 2,
  },

  EXTERNAL_USER_ROLE: {
    dev: 'dev',
    admin: 'sa',
  },

  ACCESS_TYPE_PERMISSION: {
    PERM: 'Permanent',
    EMG: 'Emergency',
    TEMP: 'Temporary',
  },

  PERSONAL_DATA: {
    N: 'NO',
    Y: 'YES',
  },

  EC2OS: [
    {
      value: '-1',
      text: 'All',
    },
    {
      value: 'windows',
      text: 'Windows',
    },
    {
      value: 'linux',
      text: 'Linux',
    },
  ],

  EC2_JOB_STATUS_CODES: {
    2201: { displayText: 'Server not reachable.' },
    2203: { displayText: 'Password update failed.' },
    2205: { displayText: 'IAM connectivity failed.' },
    2211: { displayText: 'Package installation failed.' },
    2213: { displayText: 'SELinux enabled in the linux server.' },
    2214: { displayText: 'Internet connectivity failed.' },
    2215: { displayText: 'NTP time diffrence greater than 5 mins.' },
    2217: { displayText: 'Job creation failed.' },
    2219: { displayText: 'AD filter failed.' },
    2225: { displayText: 'AD group update failed.' },
    2221: { displayText: 'Domain Config already exists' },
  },

  EC2FailureCode: [
    {
      value: -1,
      text: 'All',
    },
    {
      value: 301,
      text: 'ERROR_VPC_PEERING',
    },
    {
      value: 304,
      text: 'ERROR_SG_CREATION',
    },
    {
      value: 2013,
      text: 'ERROR_SERVER_DOMAIN_JOIN',
    },
    {
      value: 2017,
      text: 'ERROR_EC2_USER_CREATION',
    },
    {
      value: 2208,
      text: 'ERROR_HOSTNAME_RENAME',
    },
    {
      value: 6002,
      text: 'ERROR_AGENT_INSTALLATION',
    },
    {
      value: 11001,
      text: 'ERROR_PCI_DSS_PASSWORD_CHANGE',
    },
  ],

  PEERING_STATUS_CODES: {
    0: {
      text: 'All',
      status: '',
    },
    100: {
      text: 'VPC_PEERING_JOB_SUCCESS',
      status: 'Success',
    },
    12000: {
      text: 'VPC_PEERING_JOB_CREATED_SUCCESSFULLY',
      status: 'Pending',
    },
    12001: {
      text: 'ERROR_VPC_ALREADY_PEERED',
      status: 'Error',
    },
    12002: {
      text: 'ERROR_VPC_UNMANAGED',
      status: 'Error',
    },
    12003: {
      text: 'ERROR_VPC_CIDR_CLASH',
      status: 'Error',
    },
    12004: {
      text: 'ERROR_VPC_TGW_CONFIG',
      status: 'Error',
    },
    12005: {
      text: 'ERROR_VPC_PEERING_JOB',
      status: 'Error',
    },
    12006: {
      text: 'ERROR_VPC_PEERING_JOB_CREATION',
      status: 'Error',
    },
    12007: {
      text: 'ERROR_VPC_SVC_STAGE_TAG_MISMATCH',
      status: 'Error',
    },
    12008: {
      text: 'ERROR_VPC_SVC_STAGE_TAG_MISSING',
      status: 'Error',
    },
    12009: {
      text: 'ERROR_VPC_INCORRECT_IAM_API_STAGE',
      status: 'Error',
    },
    12020: {
      text: 'ERROR_VPC_NOT_FOUND',
      status: 'Error',
    },
    12021: {
      text: 'ERROR_VPC_TGW_NOT_SHARED',
      status: 'Error',
    },
  },
  TPNAT_STATUS_CODES: {
    0: {
      text: 'All',
      status: '',
    },
    100: {
      text: 'SUCCESS',
      status: 'Success',
    },
    104: {
      text: 'DELETED',
      status: 'Deleted',
    },
    12050: {
      text: 'THIRD_PARTY_ALB_SG_ADDITION_PENDING',
      status: 'Pending',
    },
    12051: {
      text: 'THIRD_PARTY_ALB_SG_REMOVAL_PENDING',
      status: 'Pending',
    },
    12052: {
      text: 'ERR_THIRD_PARTY_ALB_SG_ADDITION',
      status: 'Error',
    },
    12053: {
      text: 'ERR_THIRD_PARTY_ALB_SG_REMOVAL',
      status: 'Error',
    },
    12055: {
      text: 'ERR_THIRD_PARTY_WAF_IPSET_ADDITION',
      status: 'Error',
    },
    12056: {
      text: 'ERR_THIRD_PARTY_WAF_IPSET_REMOVAL',
      status: 'Error',
    },
    12058: {
      text: 'ERR_THIRD_PARTY_JH_SG_ADDITION',
      status: 'Error',
    },
    12059: {
      text: 'ERR_THIRD_PARTY_JH_SG_REMOVAL',
      status: 'Error',
    },
  },
  RDSFailureCode: [
    {
      value: -1,
      text: 'All',
    },
    {
      value: 301,
      text: 'ERROR_VPC_PEERING',
    },
    {
      value: 304,
      text: 'ERROR_SG_CREATION',
    },
    {
      value: 3014,
      text: 'ERROR_RDS_USER_CREATION',
    },
    {
      value: 3015,
      text: 'ERROR_RDS_USER_LOGIN',
    },
    {
      value: 3004,
      text: 'ERROR_RDS_ROLE_CREATION',
    },
    {
      value: 3062,
      text: 'ERROR_RDS_IAM_USER_PWD_CHANGE',
    },
  ],

  ERROR_CODES: {
    0: {
      message: 'Internal server error',
      error: 'ERROR_UNKNOWN',
    },
    10000: {
      message: 'Internal server error',
      error: 'ERROR_DB_INSERT_OPERATION',
    },
    10001: {
      message: 'Internal server error',
      error: 'ERROR_INVALID_SERVICE_GROUP',
    },
    10002: {
      message: 'Invalid request parameters',
      error: 'ERROR_INVALID_REQUEST_PARAMETERS',
    },
    10003: {
      message: 'Unauthorized operation',
      error: 'ERROR_UNAUTHORIZED_OPERATION',
    },
    10004: {
      message: 'Access request validation failed',
      error: 'ERROR_REQUEST_ACCESS_RULE_VALIDATION',
    },
    10005: {
      message: 'Failed to grant permission',
      error: 'ERROR_GRANT_ACCESS',
    },
    10006: {
      message: 'Failed to withdraw permission',
      error: 'ERROR_WITHDRAW_ACCESS',
    },
    10007: {
      message: 'Failed to revoke permission',
      error: 'ERROR_REVOKE_ACCESS',
    },
    10008: {
      message: 'User service group not found',
      error: 'ERROR_USER_SERVICE_GROUP_NOT_FOUND',
    },
    10009: {
      message: 'Internal server error',
      error: 'ERROR_REMOVE_ACCESS_RDS',
    },
    10010: {
      message: 'Internal server error',
      error: 'ERROR_USER_RDS_REMOVAL_USING_ANSIBLE',
    },
    10011: {
      message: 'Internal server error',
      error: 'ERROR_USER_RDS_REMOVAL_FROM_DB',
    },
    10021: {
      message: 'Internal server error',
      error: 'ERROR_USER_ADDITION_TO_AD_GROUP',
    },
    10023: {
      message: 'User ID or Password has been entered incorrectly',
      error: 'ERROR_PASSWORD_DID_NOT_MATCH',
    },
    10024: {
      message: 'Error in generating token',
      error: 'ERROR_GENERATING_USER_TOKEN',
    },
    10025: {
      message: 'Failed to change user password',
      error: 'ERROR_RESET_USER_PASSWORD',
    },
    10026: {
      message: 'User ID or Password has been entered incorrectly',
      error: 'ERROR_INVALID_USER',
    },
    10027: {
      message: 'Failed to change user status.',
      error: 'ERROR_BLOCK_UNBLOCK_USER',
    },
    10028: {
      message: 'Failed to change user role',
      error: 'ERROR_CHANGING_USER_ROLE',
    },
    10029: {
      message: 'Unable to fetch service user list',
      error: 'ERROR_FETCHING_SERVICE_DETAILS',
    },
    10030: {
      message: 'Internal server error',
      error: 'ERROR_STORING_VPC_PEERING_INFO',
    },
    10031: {
      message: 'User does not exits or Not allowed to become infra manager. Only Knox User can become infra manager',
      error: 'ERROR_WRONG_USER_TYPE',
    },
    10032: {
      message: 'Failed to create user',
      error: 'ERROR_USER_CREATION',
    },
    10033: {
      message: 'Failed to update infra manager',
      error: 'ERROR_UPDATING_INFRA_MANAGER',
    },
    10034: {
      message: 'User already exists',
      error: 'ERROR_USER_ALREADY_EXISTS',
    },
    10035: {
      message: 'Failed to create user with given userId',
      error: 'ERROR_DATA_VALIDATION_FAILED',
    },
    10036: {
      message: 'Unable to add service member',
      error: 'ERROR_SERVICE_MEMBER_ADDITION',
    },
    10037: {
      message: 'User creation failed',
      error: 'ERROR_SERVICE_OWNER_CREATION',
    },
    10051: {
      message: 'Service creation failed',
      error: 'ERROR_SERVICE_CREATION',
    },
    10061: {
      message: 'Internal server error',
      error: 'ERROR_AD_ACS_GROUP_CREATION',
    },
    10062: {
      message: 'Internal server error',
      error: 'ERROR_AD_DEFAULT_GRP_ADDITION',
    },
    10071: {
      message: 'Internal server error',
      error: 'ERROR_NO_SUCH_DB',
    },
    10072: {
      message: 'User not exists',
      error: 'ERROR_FETCHING_USER_RDS_DETAILS',
    },
    10073: {
      message: 'Internal server error',
      error: 'ERROR_FETCHING_ANSIBLE_DETAILS',
    },
    10074: {
      message: 'Resource mapping failed',
      error: 'ERROR_INSERTING_RESOURCE_MAPPING',
    },
    10081: {
      message: 'Multiple users exits',
      error: 'ERROR_MULITPLE_USER_EXIST_FOR_ID',
    },
    10082: {
      message: 'Internal server error',
      error: 'ERROR_GENERATING_IAM_TOKEN',
    },
    10083: {
      message: 'Error in mapping database',
      error: 'ERROR_DB_OP_FAILED',
    },
    10084: {
      message: 'User removal operation failed',
      error: 'ERROR_USER_REMOVAL',
    },
    10085: {
      message: 'Service user not found',
      error: 'ERROR_SERVICE_USERS_NOT_FOUND',
    },
    10086: {
      message: 'Resource not found',
      error: 'ERROR_RESOURCE_NOT_FOUND',
    },
    10087: {
      message: 'Unable to fetch Service List',
      error: 'ERROR_SERVICE_NOT_FOUND',
    },
    10088: {
      message: 'Remove user from a service failed',
      error: 'ERROR_USER_SERVICE_ACCESS',
    },
    10091: {
      message:
        'User is blocked.Please contact administrator(vd.iam@samsung.com OR nocteam@samsung.com) for further assistance',
      error: 'ERROR_USER_BLOCKED',
    },
    10095: {
      message: 'Domain join failed',
      error: 'ERROR_DOMAIN_JOIN_FAILED',
    },
    10096: {
      message: 'Whitlisted Domains not found',
      error: 'ERROR_WHITELISTED_DOMAINS_NOT_FOUND',
    },
    10097: {
      message: 'Whitlisted Domain already exist',
      error: 'ERROR_WHITELISTED_DOMAIN_ALREADY_EXISTS',
    },
    10098: {
      message: 'Add Whitlisted Domain failed',
      error: 'ERROR_ADD_WHITELISTED_DOMAIN_FAILED',
    },
    10099: {
      message: 'Delete Whitlisted Domain failed',
      error: 'ERROR_DELETE_WHITELISTED_DOMAIN_FAILED',
    },
    10100: {
      message: 'FAQ not found',
      error: 'ERROR_FAQ_NOT_FOUND',
    },
    10111: {
      message: 'Unable to fetch logs',
      error: 'ERROR_ALM_GET_SEARCH_DATA',
    },
    10115: {
      message: 'OTP authentication failed',
      error: 'ERROR_OTP_VERIFICATION',
    },
    10116: {
      message: 'User ID or Password has been entered incorrectly',
      error: 'ERROR_INVALID_USERNAME_OR_PASSWORD',
    },
    10118: {
      message: 'Failed to grant permission for public data',
      error: 'ERROR_EDIT_PRIVATE_DATA_ACCESS',
    },
    10120: {
      message: 'User Role has changed. Login Again ',
      error: 'ERROR_USER_ROLE_CHANGED',
    },
    10134: {
      message: 'User MFA authentication requirements have changed. Login Again ',
      error: 'ERROR_MFA_YN_CHANGED',
    },
    10135: {
      message: 'Invalid status code for join.',
      error: 'ERROR_INVALID_STAT_CD_JOIN',
    },
    10150: {
      message:
        'Your password has been expired, please contact IAM administrator on vd.iam@samsung.com 📧 for password reset.',
      error: 'ERROR_USR_PSWD_EXPIRED',
    },
    10167: {
      message: 'Invalid User Activation Link.',
      error: 'ERROR_INVALID_ACT_LINK',
    },
    10168: {
      message: 'Error in Sending Mail to all Users.',
      error: 'ERROR_MAIL_SEND_PVCY_PLCY_UPDATE',
    },
    10170: {
      message: 'User DBAS membership has changed.',
      error: 'ERROR_DBAS_MEMBERSHIP_CHANGED',
    },
    11000: {
      message: 'User session expired',
      error: 'ERROR_UNAUTHORIZED_ACCESS',
    },
  },

  // only for below codes check box will be enabled in Manage >> Resources >> EC2
  EC2CodesForJoin: [305, 2013, 2017, 2303],

  // Only for below Codes SG Creation Checkbox will be disabled.
  EC2SGCreateDisable: [6006],

  DOMAIN_JOIN_STATUS_CODES: {
    100: {
      displayText: 'Success',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    300: {
      displayText: 'VPC Peering Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    301: {
      displayText: 'Error VPC Peering',
      buttonText: '',
      errorInfoText: 'Error VPC Peering',
      message: 'Error VPC Peering',
    },
    302: {
      displayText: 'VPC Peering Completed',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    303: {
      displayText: 'SG Creation Pending',
      buttonText: '',
      errorInfoText: '',
      message: 'SG_CREATION_PENDING',
    },
    304: {
      displayText: 'Error SG Creation',
      buttonText: '',
      errorInfoText: 'Error SG Creation',
      message: 'Error SG Creation',
    },
    305: {
      displayText: 'Ready to Join',
      buttonText: 'Join',
      errorInfoText: '',
      message: 'SG_CREATION_COMPLETED',
    },
    2010: {
      displayText: 'Mapping Completed',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2011: {
      displayText: 'Mapping Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2012: {
      displayText: 'Domain Join Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2013: {
      displayText: 'Error Server Domain Join',
      buttonText: '',
      errorInfoText: '',
      message: 'Error Server Domain Join',
    },
    2014: {
      displayText: 'Server Domain Join Completed',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2015: {
      displayText: 'Server Domain Join Started',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2016: {
      displayText: 'EC2 User creation Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2017: {
      displayText: 'Error EC2 User Creation',
      buttonText: '',
      errorInfoText: '',
      message: 'Error EC2 User Creation',
    },
    2021: {
      displayText: 'Server Mapping Deletion Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2022: {
      displayText: 'Domain Unjoin Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2023: {
      displayText: 'Domain Unjoin Started',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2030: {
      displayText: '',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2035: {
      displayText: '',
      buttonText: '',
      errorInfoText: 'Error in connecting',
      message: '',
    },
    2045: {
      displayText: 'User removal pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2046: {
      displayText: 'User removal started',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2101: {
      displayText: 'AD Access Filter Change Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2102: {
      displayText: 'AD Access Filter Change Started',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2103: {
      displayText: 'Error AD Access Filter Change',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2123: {
      displayText: 'Error In Domain UnJoin',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2204: {
      displayText: 'Host Name rename pending',
      buttonText: '',
      errorInfoText: '',
      message: 'HOSTNAME_RENAME_PENDING',
    },
    2206: {
      displayText: '',
      buttonText: 'Rename Host',
      errorInfoText: 'Duplicate Host Name Found',
      message: '**Please note, this action will reboot the server.',
    },
    2207: {
      displayText: 'Renaming Host name',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2208: {
      displayText: 'Error Rename Host',
      buttonText: '',
      errorInfoText: '',
      message: 'Error Rename Host',
    },
    2209: {
      displayText: 'Host Rename Successfull',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2301: {
      displayText: 'Auto Join Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2302: {
      displayText: 'Auto Join Started',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    2303: {
      displayText: 'Error in Auto Join',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    3001: {
      displayText: 'RDS Info Fetch Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    3002: {
      displayText: 'RDS Role Apply Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    3003: {
      displayText: 'Error RDS Info Fetch',
      buttonText: '',
      errorInfoText: 'Error RDS Info Fetch',
      message: 'Error RDS Info Fetch',
    },
    3004: {
      displayText: 'Error RDS Role Creation',
      buttonText: '',
      errorInfoText: 'Error RDS Role Creation',
      message: 'Error RDS Role Creation',
    },
    3008: {
      displayText: 'RDS_READ_REPLICA_WRITER_NOT_ENGAGED',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    3009: {
      displayText: '',
      buttonText: 'Migrate',
      errorInfoText: '',
      message: '',
    },
    3010: {
      displayText: 'RDS Mapping Deletion Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    3011: {
      displayText: 'RDS Mapping Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    3012: {
      displayText: 'RDS Mapping Completed',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    3013: {
      displayText: 'RDS User Creation Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    3014: {
      displayText: '', // change for percentage bar
      buttonText: this.BTN_TEXT_RETRY,
      errorInfoText: 'Error RDS User Creation',
      message: 'Error RDS User Creation',
    },
    3015: {
      displayText: '', // change for percentage bar
      buttonText: 'Retry',
      errorInfoText: 'Error RDS User Login',
      message: 'Error RDS User Login',
    },
    3016: {
      displayText: 'ReJoin', // only displayed in azure mssql
      buttonText: 'ReJoin',
      errorInfoText: '',
      message: '',
    },
    3021: {
      displayText: 'RDS Connectivity Check Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    3060: {
      displayText: 'RDS IAM User PWD Change Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    3061: {
      displayText: 'RDS IAM User PWD Change Started',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    3062: {
      displayText: 'Error RDS IAM User PWD Change',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    5009: {
      displayText: 'EC2 Tag Change',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    5010: {
      displayText: 'RDS Tag Change',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    6001: {
      displayText: 'Agent Install Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    6002: {
      displayText: 'Agent Install Error',
      buttonText: '',
      errorInfoText: 'Agent Install Error',
      message: '',
    },
    6006: {
      displayText: 'Agent Install Started',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    6007: {
      displayText: 'Log Agent Removal Pending',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    6008: {
      displayText: 'Error in Removing Agent',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    6009: {
      displayText: 'Log Agent Removal Successful',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    6010: {
      displayText: 'Log Agent Update Has Started',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    6011: {
      displayText: 'Error In Updating Log Agent',
      buttonText: '',
      errorInfoText: '',
      message: '',
    },
    11001: {
      displayText: 'Error in PCI DSS password Change',
      buttonText: '',
      errorInfoText: '',
      message: 'ERROR_PCI_DSS_PASSWORD_CHANGE',
    },
    11002: {
      displayText: 'PCI DSS password Change Started',
      buttonText: '',
      errorInfoText: '',
      message: 'PCI_DSS_PASSWORD_CHANGE_STARTED',
    },
  },

  WEBCLIENT_COMMAND: {
    INIT: 'init',
    CONNECT: 'connect',
    SERVER_DISCONNECT: 'disconnect',
    CONNECT_WINSCP: 'openWinscp',
    REFRESH: 'refresh',
    GET_SERVICE_LIST: 'getServiceList',
    ACCESS_CHANGED: 'acsChanged',
    GET_RSRC_LIST: 'getResourceList',
    GET_RDS_TOKEN: 'getRdsToken',
    GET_EC2_TOKEN: 'getEc2Token',
    INVALID_USER: 'Invalid_User',
    ANOTHER_MACHINE: 'Machine details did not match',
  },

  WEBCLIENT_PROCESS_STATE: {
    CONNECTING: 'Connecting',
    CONNECTED: 'Connected',
    CONNECTINGWINSCP: 'connectingOpenWinscp',
  },

  WEBCLIENT_STATUS: {
    RUNNING: 'Running',
    Available: 'Available',
    ERROR: 'Error',
  },

  WEBEXE_RESPONSE: {
    SUCCESS: 0,
    ERROR: -1,
  },
});



// WEBPACK FOOTER //
// ./src/constants/RemConstants.js